const Store = {
  currentCall: null,
  firstCallID: '',
  inCourse: false,
  HandleVerto: null,
};

module.exports = Store;
